module.exports = __webpack_public_path__ + "media/chicken-road_afk.a6dc4b86.mp3";